import { PublicKey } from "@solana/web3.js";
import * as ReferralIDL from "./idl/referral.json";

export * from "./pda";
export * from "./referral";
export * from "./instructions";
export * from "./constant";
export * from "./type";
export * from "./discriminator";
export * from "./math";
export * from "./rpc";
export * from "./accounts";

export const REFERRAL_PROGRAM_ID = new PublicKey(ReferralIDL.address);
